import React from 'react';
import PropTypes from 'prop-types';
import Icon from './icon';
import styled from 'styled-components';
import { gray, blue } from './styles/variables';

const IndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  & > span {
    display: flex;
  }
  .material-icons-outlined {
    color: ${gray};
  }
`;

const Indicator = styled.div`
  background: ${blue};
  height: 6px;
  width: 6px;
  border-radius: 50%;
  position: absolute;
  top: 4px;
  left: 16px;
`;

const BalloonIcon = ({ icon, tooltip, large, size, trackingId }) => (
  <span
    data-balloon-blunt
    data-balloon-pos="up"
    data-trackingid={trackingId}
    aria-label={tooltip}
  >
    <Icon name={icon} size={large ? 24 : size || 13} />
  </span>
);

BalloonIcon.defaultProps = {
  large: false,
  size: null,
};

BalloonIcon.propTypes = {
  tooltip: PropTypes.string,
  icon: PropTypes.string.isRequired,
  large: PropTypes.bool,
  size: PropTypes.number,
  trackingId: PropTypes.string,
};

export const IconWithIndicator = ({ showIndicator, ...iconProps }) => {
  return (
    <IndicatorWrapper>
      <BalloonIcon {...iconProps} icon={iconProps.name || iconProps.icon} />
      {showIndicator ? <Indicator data-testid="icon_indicator" /> : null}
    </IndicatorWrapper>
  );
};

IconWithIndicator.propTypes = {
  ...BalloonIcon.propTypes,
  showIndicator: PropTypes.bool,
  name: PropTypes.string,
  icon: PropTypes.string,
};

export default BalloonIcon;
